<template>
  <div class="summary-controls">
    <b-modal v-model="showConfirmCancel" type="warn" title="Confirm Cancellation" @ok="clickConfirmCancel" ok-title="Confirm">
			<p>Please enter a reason for cancelling the social post:</p>
      <b-form-textarea
        :id="`textConfirmCancel-${deliverableDetail.id}`"
        v-model="textConfirmCancel"
        rows="3"
        ref="refTextConfirmCancel"

      ></b-form-textarea>
		</b-modal>
    <div class="action-buttons">
      <b-button
        v-for="action in validActions"
        :key="`action-button-${action}`"
        class="action-button"
        @click="clickActionButton(action)"
        :style="{ background: getAction(action).color, 'border-color': getAction(action).color }"
        :disabled="buttonsDisabled"
      >
        {{ getAction(action).name }}
      </b-button>
    </div>
  </div>
</template>

<script>

import {  mapState } from "vuex";

export default {
  data() {
    return {
      buttonsDisabled: false,
      showConfirmCancel: false,
      textConfirmCancel: "",
    }
  },
  components: {

  },
  props: ["namespace"],
  computed: {
  	...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  deliverableDetail (state, getters) {
  	    return getters[this.namespace + 'deliverableDetail']
  	  },
  	  systemSettings (state, getters) {
  	    return getters['systemSettings']
  	  },
  	  userAbilities (state, getters) {
  	    return getters['userAbilities']
  	  },
  	}),
    publishStatus(){
      return JSON.parse(this.deliverableDetail.publish_status);
    },
    publishStatusOptions(){
      return this.systemSettings.publish_statuses;
    },
    statusId(){
    	if (this.publishStatus) {
	      if(this.publishStatus.id){
	        return this.publishStatus.id;
	      }
	    }
      return 1;
    },
    statusSlug(){
    	if (this.publishStatus) {
 	     if(this.publishStatus.slug){
 	       return this.publishStatus.slug;
 		     }
 		   }
      return 'in-progress';
    },
    validActions(){
      let that = this;
      let valid = this.deliverableDetail.actions.filter(function(action){
        if(that.getAction(action)){
          return true;
        }
        return false;
      });
      return valid;
    }
    
  },
  methods: {
    getStatusById(id){
      return this.publishStatusOptions.filter(status => status.id === id)[0];
    },
    getStatusBySlug(slug){
      return this.publishStatusOptions.filter(status => status.slug == slug)[0];
    },
    
    clickConfirmCancel(e){
      if(!this.textConfirmCancel.length){
        e.preventDefault();
        document.getElementById("textConfirmCancel-"+this.deliverableDetail.id).focus();
        return;
      }
      this.buttonsDisabled = true;
      let that = this;
      that.$store.dispatch(this.namespace + "updateDeliverablePublishStatusBySlug", {
        id: that.deliverableDetail.id,
        value: "cancelled",
        notes: that.textConfirmCancel,
        return_master:true
      }).then(function(){
        that.buttonsDisabled = false;
      });
    },
    clickActionButton(slug){
      switch(slug){
        case 'cancel-post':
          this.showConfirmCancel = true;
           this.$nextTick(() => {
    	       this.$refs.refTextConfirmCancel.focus();
           });
          break;
        default:
          let that = this;
          this.buttonsDisabled = true;
          this.$store.dispatch(this.namespace + "doAction", {
            deliverable_id: this.deliverableDetail.id,
            return_id: this.deliverableDetail.id,
            action: slug,
          }).then(function(){
            that.$emit('task-status-updated');
            that.buttonsDisabled = false;
          });
      }
      
    },
    getAction(slug){
      let actions = this.systemSettings.actions.filter(function(action){
        if(action.slug === slug){
          return true;
        }
        return false;
      });
      if(actions.length){
        return actions[0];
      }
      return false;
    },
  },
  created(){
    
  },
}
</script>